module.exports = __webpack_public_path__ + "static/media/sariet.a53ab56c.jpg";